export enum EAuthModes {
  SIGN_IN = "SIGN_IN",
  SIGN_UP = "SIGN_UP",
}

export enum EAuthSteps {
  EMAIL = "EMAIL",
  PASSWORD = "PASSWORD",
  UNIQUE_CODE = "UNIQUE_CODE",
  // NG-1370 (FR28): the workspace's domain is SSO-enabled but no identity
  // provider is live for it — fail closed rather than a password field or an
  // SSO redirect that would only be rejected server-side.
  SSO_UNAVAILABLE = "SSO_UNAVAILABLE",
}

export enum EAuthenticationErrorCodes {
  INSTANCE_NOT_CONFIGURED = "5000",
  INVALID_EMAIL = "5005",
  EMAIL_REQUIRED = "5010",
  SIGNUP_DISABLED = "5015",
  MAGIC_LINK_LOGIN_DISABLED = "5016",
  PASSWORD_LOGIN_DISABLED = "5018",
  USER_ACCOUNT_DEACTIVATED = "5019",
  INVALID_PASSWORD = "5020",
  SMTP_NOT_CONFIGURED = "5025",
  USER_ALREADY_EXIST = "5030",
  AUTHENTICATION_FAILED_SIGN_UP = "5035",
  REQUIRED_EMAIL_PASSWORD_SIGN_UP = "5040",
  INVALID_EMAIL_SIGN_UP = "5045",
  INVALID_EMAIL_MAGIC_SIGN_UP = "5050",
  MAGIC_SIGN_UP_EMAIL_CODE_REQUIRED = "5055",
  USER_DOES_NOT_EXIST = "5060",
  AUTHENTICATION_FAILED_SIGN_IN = "5065",
  REQUIRED_EMAIL_PASSWORD_SIGN_IN = "5070",
  INVALID_EMAIL_SIGN_IN = "5075",
  INVALID_EMAIL_MAGIC_SIGN_IN = "5080",
  MAGIC_SIGN_IN_EMAIL_CODE_REQUIRED = "5085",
  INVALID_MAGIC_CODE_SIGN_IN = "5090",
  INVALID_MAGIC_CODE_SIGN_UP = "5092",
  EXPIRED_MAGIC_CODE_SIGN_IN = "5095",
  EXPIRED_MAGIC_CODE_SIGN_UP = "5097",
  EMAIL_CODE_ATTEMPT_EXHAUSTED_SIGN_IN = "5100",
  EMAIL_CODE_ATTEMPT_EXHAUSTED_SIGN_UP = "5102",
  OAUTH_NOT_CONFIGURED = "5104",
  GOOGLE_NOT_CONFIGURED = "5105",
  GOOGLE_OAUTH_PROVIDER_ERROR = "5115",
  INVALID_PASSWORD_TOKEN = "5125",
  EXPIRED_PASSWORD_TOKEN = "5130",
  INCORRECT_OLD_PASSWORD = "5135",
  MISSING_PASSWORD = "5138",
  INVALID_NEW_PASSWORD = "5140",
  PASSWORD_ALREADY_SET = "5145",
  DOMAIN_REQUIRED = "5200",
  DOMAIN_NOT_CONFIGURED = "5201",
  DOMAIN_NOT_FOUND = "5205",
  DOMAIN_NOT_VERIFIED = "5210",
  DOMAIN_VERIFICATION_FAILED = "5215",
  WORKSPACE_NOT_FOUND = "5230",
  SSO_NOT_CONFIGURED = "5260",
  RATE_LIMIT_EXCEEDED = "5900",
  ACCOUNT_LOCKED = "5905",
  // NG-1762, FR51: a session ended by the workspace-configured idle timeout or
  // absolute ceiling. The backend sends this on that specific 401, and
  // authErrorHandler renders it as the "session expired" banner.
  SESSION_EXPIRED = "5910",
  // NG-2471: no session at all (the cookie aged out, a sign-out in another
  // tab, a flushed row). The backend answers a session caller 403 here, not
  // 401, and marks it with this code so the interceptor can tell it from a
  // permission denial and route to sign-in.
  NOT_AUTHENTICATED = "5911",
}
